module.exports = __webpack_public_path__ + "static/img/首页banner2.07fffae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/新建文件夹/首页banner2.png
// module id = i97G
// module chunks = 192